import { render, staticRenderFns } from "./index.vue?vue&type=template&id=75491ced&scoped=true&functional=true&"
var script = {}
import style0 from "./style.sass?vue&type=style&index=0&id=75491ced&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "75491ced",
  null
  
)

export default component.exports